/* eslint-disable camelcase */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 12,
    color: '#1e3f9e',
    maxWidth: 650,
  },
  list: {
    fontSize: 12,
  },
}));

const MqttSetup = () => {
  const classes = useStyles();
  return (
    <div>
      <h4 className={classes.title}> Follow the instructions below and click CONTINUE.</h4>
      <ol className={classes.list}>
        <li>From the menu, select Control &#8594; Macro</li>
        <li>In the file explorer, find and select the file you edited, "Neuralert-MQTT-script-&lt;deviceId&gt;.ttl"</li>
        <li>Once the script has run, type 'user' and then 'run 1' to start the monitor</li>
        <li>
          Restart the monitor by holding the power button until the text stops running inside Tera Term, then pressing
          the power button again
        </li>
      </ol>
    </div>
  );
};

export default MqttSetup;
